import { render } from "./Hotline.vue?vue&type=template&id=8efe4950&scoped=true"
import script from "./Hotline.vue?vue&type=script&lang=js"
export * from "./Hotline.vue?vue&type=script&lang=js"

import "./Hotline.vue?vue&type=style&index=0&id=8efe4950&scoped=true&lang=css"

import exportComponent from "D:\\wamp64\\www\\comd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8efe4950"]])

export default __exports__